import { useEffect, useState } from "react";
import { Bell, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePushNotifications } from "@/hooks/usePushNotifications";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

const PROMPT_KEY = "ugc_push_prompted";

export const PushNotificationPrompt = () => {
  const { user } = useAuth();
  const { isSupported, permission, isSubscribed, loading, subscribe } = usePushNotifications();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || !isSupported || isSubscribed || permission === "denied") return;
    if (localStorage.getItem(PROMPT_KEY)) return;
    if (sessionStorage.getItem(PROMPT_KEY)) return;
    const t = setTimeout(() => setShow(true), 4000);
    return () => clearTimeout(t);
  }, [user, isSupported, isSubscribed, permission]);

  if (!show || !user || !isSupported || isSubscribed) return null;

  const handleEnable = async () => {
    const ok = await subscribe();
    if (ok) {
      toast.success("Bildirimler açıldı! Videon hazır olunca haber vereceğiz.");
      localStorage.setItem(PROMPT_KEY, "granted");
      setShow(false);
    } else if (permission === "denied") {
      toast.error("Bildirim izni reddedildi. Tarayıcı ayarlarından açabilirsin.");
      localStorage.setItem(PROMPT_KEY, "denied");
      setShow(false);
    }
  };

  const handleDismiss = () => {
    setShow(false);
    sessionStorage.setItem(PROMPT_KEY, "dismissed");
  };

  return (
    <div className="fixed bottom-4 right-4 z-[60] w-[340px] max-w-[calc(100vw-2rem)] animate-in slide-in-from-bottom-3">
      <div className="rounded-xl border border-border bg-card shadow-xl p-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
            <Bell className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-sm">Bildirimleri Aç</p>
            <p className="text-xs text-muted-foreground mt-0.5">
              Videon hazır olunca, ödemen onaylanınca anında haber verelim.
            </p>
            <div className="flex gap-2 mt-3">
              <Button size="sm" onClick={handleEnable} disabled={loading}>
                <Bell className="w-3.5 h-3.5 mr-1" />
                {loading ? "Açılıyor..." : "İzin Ver"}
              </Button>
              <Button size="sm" variant="ghost" onClick={handleDismiss}>
                Sonra
              </Button>
            </div>
          </div>
          <button onClick={handleDismiss} className="text-muted-foreground hover:text-foreground p-1">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
